import { render, staticRenderFns } from "./proyeccionleads.vue?vue&type=template&id=b6ce79f0"
import script from "./proyeccionleads.vue?vue&type=script&lang=js"
export * from "./proyeccionleads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports